import { FC } from "react";

const HideSVG: FC = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Hide</title>
            <g clipPath="url(#clip0_145_167)" transform="translate(-0.373, 0)">
                <path
                    d="M13.9945 11.3333C14.154 10.907 14.235 10.4552 14.2334 10C14.2334 8.98923 13.8318 8.01986 13.1171 7.30514C12.4024 6.59041 11.433 6.18889 10.4223 6.18889C9.97264 6.18941 9.52674 6.27032 9.10559 6.42778L10 7.35C10.136 7.32825 10.2735 7.3171 10.4111 7.31667C11.1258 7.31517 11.8121 7.59652 12.32 8.09927C12.828 8.60203 13.1164 9.28534 13.1223 10C13.1218 10.1377 13.1107 10.2751 13.0889 10.4111L13.9945 11.3333Z"
                    fill="#D8FFF3"
                    fillOpacity="0.81"
                />
                <path
                    d="M19.05 9.73889C17.1778 6.27778 13.8944 4.18333 10.2611 4.18333C9.27184 4.18566 8.28923 4.34505 7.34998 4.65556L8.24442 5.55556C8.90323 5.3853 9.58064 5.29759 10.2611 5.29445C13.3889 5.29445 16.2333 7.03889 17.9278 9.97778C17.3062 11.0681 16.4822 12.0298 15.5 12.8111L16.2889 13.6C17.4256 12.683 18.3696 11.5501 19.0666 10.2667L19.2111 10L19.05 9.73889Z"
                    fill="#D8FFF3"
                    fillOpacity="0.81"
                />
                <path
                    d="M2.7056 3.21111L5.18338 5.68889C3.61722 6.69728 2.33721 8.09209 1.46671 9.73889L1.32227 10L1.46671 10.2667C3.33893 13.7278 6.62226 15.8222 10.2556 15.8222C11.6737 15.8219 13.0735 15.501 14.35 14.8833L17.1278 17.6611L18.1 16.8278L3.6556 2.38333L2.7056 3.21111ZM8.12227 8.62778L11.8167 12.3222C11.3993 12.5806 10.9187 12.719 10.4278 12.7222C10.0711 12.7222 9.71793 12.6517 9.38859 12.5147C9.05924 12.3777 8.76024 12.1769 8.50879 11.9239C8.25733 11.6709 8.05839 11.3707 7.92341 11.0405C7.78843 10.7103 7.72007 10.3567 7.72227 10C7.72853 9.51476 7.86681 9.04038 8.12227 8.62778ZM7.31671 7.82222C6.79695 8.55522 6.55334 9.4485 6.629 10.3439C6.70466 11.2393 7.09471 12.079 7.7301 12.7144C8.36549 13.3498 9.20522 13.7398 10.1006 13.8155C10.996 13.8912 11.8893 13.6475 12.6223 13.1278L13.5112 14.0167C12.4821 14.4565 11.3747 14.6833 10.2556 14.6833C7.12782 14.6833 4.28338 12.9389 2.58893 10C3.4021 8.56012 4.57322 7.35455 5.98893 6.5L7.31671 7.82222Z"
                    fill="#D8FFF3"
                    fillOpacity="0.81"
                />
            </g>
            <defs>
                <clipPath id="clip0_145_167">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default HideSVG;
